import { useFormikContext } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { Prompt } from "react-router-dom";
export var DirtyFormPrompt = React.memo(function () {
    var formik = useFormikContext();
    var intl = useIntl();
    return (React.createElement(Prompt, { when: formik.dirty && !formik.isSubmitting, message: intl.formatMessage({ id: "forms.unsaved_prompt" }) }));
});
